import React from "react"
import InlineCode from "../../components/inlineCode"
import Layout from "../../components/layout"
import { CodeExample } from "../../components/validatorFuncs"

const forExample1 = `var validator = new ValidatorBuilder<Employee>()
    // FirstName is required with min length of 2 and must contain the letter 'p'
    .For(e => e.FirstName, name => 
        {
            name.Required()
                .MinLength(2)
                .Contains("p");
        })
    // Address must be set with AddressLine1, Postcode and Region required and
    // the Country must equal Australia
    .For(e => e.Address, addr => 
        {
            addr.NotNull()
                .Required(a => a.AddressLine1)
                .Required(a => a.PostCode)
                .Required(a => a.Region)
                .Equal(a => a.Country, "Australia");
        })
    .Build();

// this will not validate
var result = validator.Validate(
    new Employee 
    {
        FirstName = "Steve",
        Address = new Address
        {
            AddressLine1 = "742 Evergreen Terrace",
            PostCode = "3500",
            Region = "VIC",
            Country = "Australia"
        }
    });`

const ForFunction = () => (
  <Layout>
    <h1>
      <em>For</em> Function
    </h1>
    <p>
      In Validatum, the <InlineCode>For</InlineCode> function is an extension
      method used to build a validator that targets the type returned from a
      selector expression.
    </p>
    <p>
      The <InlineCode>For</InlineCode> function can be used to create very
      complex nested validation functions against the properties (and nested
      properties) of complex types.
    </p>
    <p>
      The selector expression makes it easy to target a property, retrieve its
      value at runtime, and build a nested inline validator against the
      property's type.
    </p>
    <hr className="my-6" />
    <h5 className="font-semibold text-sm">Method</h5>
    <div className="my-4">
      <InlineCode
        className="text-sm text-blue-600 bg-blue-100 font-semibold"
        code="For<T, P>(Expression<Func<T, P>> selector, Action<IValidatorBuilder<P>> func)"
      />
    </div>
    <p className="mt-4">
      The first parameter is the selector expression (a type of lambda
      expression)
    </p>
    <p>
      The second parameter is a function that provides an{" "}
      <InlineCode code="IValidatorBuilder<P>" /> that will target the return
      type <InlineCode>P</InlineCode> (<em>Note the second type parameter</em>).
    </p>
    <h5 className="font-semibold text-gray-800 text-sm my-4">Example Usage</h5>
    <CodeExample code={forExample1} />
  </Layout>
)

export default ForFunction
